import { lazy, Suspense } from "react";

import RouteLoadingIndicator from "components/RouteLoadingIndicator/RouteLoadingIndicator";


const LazyContainer = lazy(() => import("./Shortlink.container"));

const Container = (props) =>
  <Suspense fallback={<RouteLoadingIndicator />}>
    <LazyContainer {...props} />
  </Suspense>;

export default Container;
